<mat-sidenav-container class="sidenav-container">
   <mat-sidenav #sidenav mode="side" opened="true" position="start" class="sidenav-list">
      <ng-content select="[two-column-list-content-layout-list]"></ng-content>
   </mat-sidenav>
   <mat-sidenav-content class="sidenav-content">
      <ng-content></ng-content>
      <router-outlet></router-outlet>
   </mat-sidenav-content>
</mat-sidenav-container>
